<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>   
    <template v-slot:right_view>
      <NSIList></NSIList>
    </template>
  </BasicLayout>
</template>
<script>
import BasicLayout from '../../layouts/BasicLayout';
import NSIList from '../../components/nsmfconfig/nsi/NSIList';

export default {
  name: 'nsiPage',
  components: {
    BasicLayout,
    NSIList
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('NSMF.nsmfManage')}/${this.$t('NSMF.nsi')}`
      }
    };
  }
};
</script>